/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-access.reducer';

export const ParamedicAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicAccessEntity = useAppSelector(state => state.paramedicAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicAccess.detail.title">ParamedicAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{paramedicAccessEntity.comboUser ? paramedicAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{paramedicAccessEntity.glucoUser ? paramedicAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-access/${paramedicAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicAccessDetail;
